import { FC } from 'react';
import { sanitizeHtml } from '@new/common/lib/sanitize';

interface Goal {
  id: number;
  text: string;
}

interface DegreeDescriptionProps {
  longDescription?: string;
  shortDescription?: string;
  goals?: Goal[];
}

export const DegreeDescription: FC<DegreeDescriptionProps> = ({
  longDescription,
  shortDescription,
  goals,
}) => {
  return (
    <div className="flex w-full min-w-0 flex-col gap-6">
      <div className="flex w-full min-w-0 flex-col gap-1">
        <h4 className="[font-size:var(--fs-h6)]! lg:[font-size:var(--fs-h4)]! text-(--neutral-black-NB1000)! bold m-0!">
          Description
        </h4>

        {longDescription ? (
          <div
            className="w-full min-w-0 wrap-break-word text-(--neutral-black-NB900)! [&_p]:m-0! [&_p]:[font-size:var(--fs-p3)] [&_p]:text-(--neutral-black-NB900)"
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(longDescription),
            }}
          />
        ) : (
          <p className="[font-size:var(--fs-p4)]! lg:[font-size:var(--fs-p2)]! text-(--neutral-black-NB900)! m-0!">
            {shortDescription}
          </p>
        )}
      </div>

      {goals && goals.length > 0 && (
        <div className="flex w-full flex-col items-start gap-1">
          <h4 className="[font-size:var(--fs-h6)]! lg:[font-size:var(--fs-h4)]! text-(--neutral-black-NB1000)! bold m-0!">
            Aims
          </h4>

          <div className="flex w-full flex-col items-start gap-2">
            {goals.map((goal) => (
              <div key={goal.id} className="flex w-full min-w-0 items-center justify-start gap-3">
                <div className="h-3.5 w-3.5 shrink-0 bg-(--secondary-B200)" />

                <p className="min-w-0 flex-1 [font-size:var(--fs-p4)]! lg:[font-size:var(--fs-p3)]! text-(--neutral-black-NB900)! m-0!">
                  {goal.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
